import { ProductIdentifier } from '@platform-frontend/marketplace';
import { RefreshSignInMessageParams } from './checkout-sanitized-start-params';

export interface SignInFlow {
  type: 'SIGN_IN';
  startParams: RefreshSignInMessageParams;
  productIdentifier?: ProductIdentifier;
}

export const SIGN_IN_FLOW_DEFAULT: SignInFlow = {
  type: 'SIGN_IN',
  startParams: { vendorId: null, locale: null, metadataId: null }
};
